import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLoader } from '../../../helpers/useLoader';
import { ProjectDetailsHeader } from '../components/ProjectDetailsHeader';
import { IProjectDetailsBl } from '../projectDetails.bl';

export const ProjectDetailsHeaderContainer = observer((): ReactElement => {
  const projectDetailsBl = useInjection(IProjectDetailsBl.$);
  const { withLoaderAsync } = useLoader();

  const { projectId } = useParams<{ projectId: string }>();

  useEffect(() => {
    const initialize = async (): Promise<void> => {
      projectDetailsBl.initialize();
      await projectDetailsBl.getProjectDetailsAsync(projectId);
    };
    void initialize();
  }, [projectId]);

  const handleNameChange = (name: string): void => {
    projectDetailsBl.changeName(name);
  };

  const handleNameBlurAsync = async (): Promise<void> => {
    await withLoaderAsync(async () => {
      await projectDetailsBl.nameChangedAsync();
    }, 'publish-loader');
  };

  const handleDescriptionChange = (description: string): void => {
    projectDetailsBl.changeDescription(description);
  };

  const handleDescriptionBlurAsync = async (): Promise<void> => {
    await projectDetailsBl.descriptionChangedAsync();
  };

  const { name, description, nameStatus, descriptionStatus, id, createdDate, createdBy, modelVariant } = projectDetailsBl.store;

  return (
    <ProjectDetailsHeader
      id={id}
      name={name}
      description={description}
      createdDate={createdDate}
      createdBy={createdBy}
      modelVariant={modelVariant}
      onNameChange={handleNameChange}
      onDescriptionChange={handleDescriptionChange}
      onNameBlur={handleNameBlurAsync}
      onDescriptionBlur={handleDescriptionBlurAsync}
      nameMaxLength={200}
      descriptionMaxLength={500}
      nameStatus={nameStatus}
      descriptionStatus={descriptionStatus}
      projectStatus={projectDetailsBl.store.status}
    />
  );
});
